import { useContext } from 'react';
import {
  ChangeWarrantyModalDispatchContext,
  ChangeWarrantyModalStateContext,
} from './provider';

export const useChangeWarrantyModalState = () => {
  const context = useContext(ChangeWarrantyModalStateContext);
  if (context === undefined) {
    throw new Error(
      'useChangeWarrantyModalState должен использоваться внутри ToggleChangeWarrantyModalProvider'
    );
  }
  return context;
};

export const useChangeWarrantyModalDispatch = () => {
  const context = useContext(ChangeWarrantyModalDispatchContext);
  if (context === undefined) {
    throw new Error(
      'useChangeWarrantyModalDispatch должен использоваться внутри ToggleChangeWarrantyModalProvider'
    );
  }
  return context;
};
